function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  fill: "#FAFAFA",
  stroke: "#FAFAFA"
});

var SvgNotificationsYellow = function SvgNotificationsYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4794 12.3166C18.5353 12.1417 18.7307 12 18.9164 12H22.9125C23.0979 12 23.1905 12.1401 23.1211 12.3087L21.0416 17.3589C20.9714 17.5294 21.0664 17.6677 21.2487 17.6677H24.5809C24.7655 17.6677 24.8225 17.7834 24.7052 17.93L17.7474 26.6274C17.287 27.2029 17.0949 27.1 17.3176 26.4002L19.1472 20.65C19.2026 20.4759 19.0956 20.3348 18.9156 20.3348H16.2454C16.0621 20.3348 15.9599 20.1901 16.0149 20.0182L18.4794 12.3166Z",
    style: {
      fill: "var(--color-primary)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationsYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifications-yellow.70576d6f.svg";
export { ForwardRef as ReactComponent };